enum PrintProductTypeLiteral {
  DIGITAL = 'D',
  MAGAZINE = 'M',
  PRINT = 'P',
}

export default PrintProductTypeLiteral;
